const token = localStorage.getItem('token');

const myHeaders = new Headers();
if (token) {
  myHeaders.append('Authorization', `Token ${token}`);
}
myHeaders.append('Content-Type', 'application/json');

export const API_URL = String(process.env.API_URL);

export const postData = async (url = '', data = {}, options = {}) => {
  const isFormData = data instanceof FormData;

  const postDataMyHeaders = myHeaders;

  if (isFormData) {
    postDataMyHeaders.delete('Content-Type');
  }

  return fetch(url, {
    method: 'POST',
    headers: postDataMyHeaders,
    body: isFormData ? data : JSON.stringify(data),
  }).catch((error) => {
    throw error;
  });
};

// export const postDataLogin = (url = '', data = {}) => {
//   const loginHeader = new Headers();
//   loginHeader.append('Content-Type', 'application/json');

//   return fetch(url, {
//     method: 'POST',
//     headers: loginHeader,
//     body: JSON.stringify(data),
//   }).catch((error) => console.log(error));
// };

// export const postDataFile = (url = '', data = {}) => {
//   const myHeadersFile = new Headers();
//   if (token) {
//     myHeadersFile.append('Authorization', `Token ${token}`);
//   }
//   return fetch(url, {
//     method: 'POST',
//     headers: myHeadersFile,
//     body: data,
//   }).catch((error) => console.log(error));
// };

// export const putDataNew = (url = '', data = {}) => {
//   console.log(data);
//   return fetch(url, {
//     method: 'PUT',
//     headers: myHeaders,
//     body: JSON.stringify(data),
//   }).catch((error) => console.log(error));
// };

export const putData = (url = '', data = {}, files = false) => {
  if (files) {
    const myHeadersFile = new Headers();

    if (token) {
      myHeadersFile.append('Authorization', `Token ${token}`);
    }

    return fetch(url, {
      method: 'PUT',
      headers: myHeadersFile,
      body: data,
    }).catch((error) => console.log(error));
  } else {
    return fetch(url, {
      method: 'PUT',
      headers: myHeaders,
      body: JSON.stringify(data),
    }).catch((error) => console.log(error));
  }
};

// export const patchData = (url = '', data = {}, files = false) => {
//   if (files) {
//     const myHeadersFile = new Headers();

//     if (token) {
//       myHeadersFile.append('Authorization', `Token ${token}`);
//     }

//     return fetch(url, {
//       method: 'PATCH',
//       headers: myHeadersFile,
//       body: data,
//     }).catch((error) => console.log(error));
//   } else {
//     console.log({ ...data });
//     return fetch(url, {
//       method: 'PATCH',
//       headers: myHeaders,
//       body: JSON.stringify(data),
//     }).catch((error) => console.log(error));
//   }
// };

// export const delData = async (url = '', data = {}) => {
//   try {
//     const response = await fetch(url, {
//       method: 'DELETE',
//       headers: myHeaders,
//       body: Object.keys(data).length > 0 ? JSON.stringify(data) : undefined,
//     });

//     if (response.status === 204) {
//       return { ok: true, status: 'success' };
//     }

//     if (response.ok) {
//       try {
//         return await response.json();
//       } catch (e) {
//         return { ok: true, status: 'success' };
//       }
//     }

//     try {
//       const errorData = await response.json();
//       return {
//         ok: false,
//         status: 'error',
//         message: errorData.message || errorData.detail || 'Ошибка при удалении',
//         statusCode: response.status,
//       };
//     } catch (e) {
//       return {
//         ok: false,
//         status: 'error',
//         message: `${response.status}`,
//         statusCode: response.status,
//       };
//     }
//   } catch (error) {
//     console.error('Ошибка при выполнении DELETE-запроса:', error);
//     return {
//       ok: false,
//       status: 'error',
//       message: error.message || 'Сетевая ошибка при удалении',
//       error,
//     };
//   }
// };

export const delCashbox = (url = '') => {
  return fetch(url, {
    method: 'DELETE',
    headers: myHeaders,
  }).catch((error) => console.log(error));
};

export { myHeaders };
